// ATC
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.collectionItem').forEach((el) => {
        const atcButton = el.querySelector('.collectionItemActionsAtc');
        const variantSelect = el.querySelector('.collectionItemActionsVariantSelect');

        // update variant on select change
        variantSelect?.addEventListener('change', function (e) {
            atcButton.dataset.variant = e.target.value;

            // get price
            const selectedOption = variantSelect.querySelector(`option[value="${e.target.value}"]`);

            const realPrice = parseInt(selectedOption.dataset.price);
            const comparePrice = parseInt(selectedOption.dataset.comparePrice);

            // update price html
            el.querySelector('.collectionItemPrice').innerHTML = `
               <span class="sale">${price(realPrice)}</span>
               <span>${comparePrice > realPrice ? price(comparePrice) : ''}</span>
            `;
        });


        // atc
        atcButton.addEventListener('click', async function (e) {
            // loading
            this.classList.add('loading');

            // add to cart
            await addProduct({
                items: [
                    {
                        quantity: 1,
                        id: parseInt(this.dataset.variant)
                    }
                ]
            });

            // remove loading
            this.classList.remove('loading');

            // open cart
            await openCart();
        });
    });
});